import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {gsap} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DevilsCrossRoad} from "../DevilsCrossRoad";
import {DevilsCrossRoadGameAssets} from "../DevilsCrossRoadGameAssets";
import {DevilsCrossRoadSound} from "../sound/DevilsCrossRoadSound";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {DevilsCrossRoadGameMode} from "../server/DevilsCrossRoadGameMode";


export class EndBonusView extends PIXI.Container implements StageLayer {

    name = "EndBonusView";

    private totalValueText: PIXI.BitmapText;
    private _currentValue: number = 0;
    private _coinsToKill:TimelineSprite [] = [];
    private textStyle:PIXI.TextStyle = new PIXI.TextStyle(
        {
            fill : 0xFFBF00,
            fontFamily : OpenSans.FAMILY,
            wordWrap : false,
            fontWeight : FontWeight.BOLD,
            fontSize : 120,
            dropShadow: true,
            dropShadowColor: "black",
            dropShadowBlur: 1,
            dropShadowDistance: 8,
            dropShadowAlpha: 0.8
        });

    constructor() {
        super();

        this.createText();
        //this.visible = false;
    }

    private createText(): void {

        this.totalValueText = new PIXI.BitmapText("", {
            fontName: DevilsCrossRoadGameAssets.BITMAP_FONT_NUMBERS_FS_WIN,
            fontSize : 160
        });
        this.totalValueText.position.set(360, 360);
        this.totalValueText.anchor = 0.5;

        this.addChild(this.totalValueText);
        this.totalValueText.alpha = 0.5;
    }

    public addCoinSprite(coin:TimelineSprite): void {
        this._coinsToKill.push(coin);
        this.addChild(coin);
    }

    public reset(): void {
        this._coinsToKill.forEach((coin) => {
            coin.hide();
            coin.stopLoop();
            this.removeChild(coin);
            //coin.destroy();
        });
        this._currentValue = 0;
        this.totalValueText.text = "";
        this.totalValueText.visible = false;
    }

    public show():void {
        this.visible = true;
    }

    public updateTextAnimationWinCap():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._currentValue = DevilsCrossRoad.model.gameData.totalSpinWinnings;
            this.visible = true;
            this.totalValueText.visible = true;
            if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_MULTIPLIER_FINAL)?.isPlaying) {
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_MULTIPLIER_FINAL});
            }
            DevilsCrossRoadSound.fadeAndStopSound({name:DevilsCrossRoadSound.FS_MULTIPLIER_COUNTUP,to:0,duration:100});
        });

        tl.add([
            gsap.fromTo(this.totalValueText, 0.3, {alpha: 0.8}, {alpha: 1}),
        ]);
        tl.add([
            gsap.fromTo(this.totalValueText.scale, 0.3, {x: 0.8, y: 0.8}, {x: 1.3, y: 1.3, ease : "power3.out"}),
        ], "<");
        tl.add([
            gsap.fromTo(this.totalValueText.scale, 0.3, {x: 1.3, y: 1.3}, {x: 1, y: 1, ease : "power3.in"}),
        ]);
        tl.add(() => {
            this.totalValueText.text = "x" + this._currentValue.toString();
        }, "<0.05");

        return tl;
    }

    public transitionIntoEndBW():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add([
            gsap.to(this.totalValueText.scale, 1, {x: 0.65, y: 0.65, ease : "power3.out"}),
            ()=>{
                DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_MULTIPLIER_FINAL});
                DevilsCrossRoadSound.fadeAndStopSound({name:DevilsCrossRoadSound.FS_MULTIPLIER_COUNTUP,to:0,duration:100});
            }
        ]);
        tl.add([
            gsap.fromTo(this.totalValueText.scale, 1, {x: 2.3, y: 2.3}, {x: 1, y: 1, ease : "power3.out"}),
            gsap.fromTo(this.totalValueText, 1, {alpha: 1}, {alpha: 0, ease : "power3.out"}),
        ]);
        tl.add(() => {
            this.totalValueText.text = "x" + this._currentValue.toString();
        });


        tl.add(() => {
            this.totalValueText.visible = false;
        });

        return tl;
    }


    public updateTextAnimation(coinValue: number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this._currentValue += coinValue;
            this.visible = true;
            this.totalValueText.visible = true;
        });
        tl.add(() => {
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_MULTIPLIER});
        });

        if (coinValue < 100) {
            tl.add([
                gsap.fromTo(this.totalValueText, 0.1, {alpha: 0.8}, {alpha: 1}),
            ]);
            tl.add([
                gsap.fromTo(this.totalValueText.scale, 0.1, {x: 0.8, y: 0.8}, {x: 1, y: 1}),
            ], "<");
            tl.add(() => {
                this.totalValueText.text = "x" + this._currentValue.toString();
            }, "<0.05");
        }
        else {
            tl.add([
                gsap.fromTo(this.totalValueText, 0.3, {alpha: 0.8}, {alpha: 1}),
            ]);
            tl.add([
                gsap.fromTo(this.totalValueText.scale, 0.3, {x: 0.8, y: 0.8}, {x: 1.3, y: 1.3, ease : "power3.out"}),
            ], "<");
            tl.add([
                gsap.fromTo(this.totalValueText.scale, 0.3, {x: 1.3, y: 1.3}, {x: 1, y: 1, ease : "power3.in"}),
            ]);
            tl.add(() => {
                this.totalValueText.text = "x" + this._currentValue.toString();
            }, "<0.05");
        }

        return tl;
    }

    onOrientationChanged() {

    }

}